import withSharedStyles from "../theme/Shared.style";

const withCustomStyles = withSharedStyles(theme => {
  const { color, radius, control, fontSize, shadow } = theme.tokens;
  return {
    search: {
      position: "relative",
      width: "100%",
      margin: 0
    },
    pill: {
      display: "flex",
      alignItems: "center",
      gap: 12,
      height: control.md,
      padding: "0 20px",
      borderRadius: radius.pill,
      backgroundColor: color.field,
      cursor: "text",
      boxSizing: "border-box",
      transition: "box-shadow .15s",
      "&:focus-within": { boxShadow: shadow.selected }
    },
    icon: {
      fontSize: theme.tokens.iconSize.md,
      color: color.ink,
      flex: "none"
    },
    inputWrap: {
      position: "relative",
      flex: 1,
      minWidth: 0,
      display: "flex"
    },
    placeholder: {
      position: "absolute",
      top: "50%",
      left: 0,
      right: 0,
      height: 24,
      marginTop: -12,
      overflow: "hidden",
      pointerEvents: "none",
      color: color.muted,
      fontSize: fontSize.body
    },
    placeholderTrack: {
      display: "flex",
      flexDirection: "column"
    },
    placeholderAnimate: {
      transition: "transform .4s ease",
      "@media (prefers-reduced-motion: reduce)": { transition: "none" }
    },
    placeholderItem: {
      height: 24,
      lineHeight: "24px",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis"
    },
    inputRoot: {
      flex: 1,
      minWidth: 0,
      color: color.ink
    },
    inputInput: {
      padding: 0,
      height: 24,
      fontSize: fontSize.body,
      "&::placeholder": { color: color.muted, opacity: 1 },
      "&::-webkit-search-cancel-button": { WebkitAppearance: "none" },
      "&:focus-visible": { outline: "none" }
    },
    dropdown: {
      position: "absolute",
      top: "calc(100% + 8px)",
      left: 0,
      right: 0,
      zIndex: 1000,
      maxHeight: 360,
      overflowY: "auto",
      padding: 8,
      borderRadius: radius.card,
      backgroundColor: color.bg,
      boxShadow: `${shadow.overlay}, ${shadow.hairline}`
    },
    list: {
      listStyle: "none",
      margin: 0,
      padding: 0
    },
    option: {
      display: "flex",
      alignItems: "center",
      gap: 12,
      minHeight: control.icon,
      padding: "6px 10px",
      borderRadius: radius.field,
      cursor: "pointer",
      fontSize: fontSize.body,
      color: color.ink,
      "&:hover": { backgroundColor: color.surface }
    },
    optionActive: {
      backgroundColor: color.field,
      "&:hover": { backgroundColor: color.field }
    },
    thumb: {
      width: 36,
      height: 36,
      flex: "none",
      borderRadius: 10,
      backgroundColor: color.surface,
      overflow: "hidden",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      "& img": {
        width: "100%",
        height: "100%",
        objectFit: "contain",
        mixBlendMode: "multiply"
      }
    },
    optionText: {
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap"
    },
    status: {
      padding: "12px 10px",
      fontSize: fontSize.ui,
      color: color.muted
    }
  };
});

export default withCustomStyles;
